import Axios from 'axios'
import {genderUrl} from '../urls'

export default {
  get_all_genders (context) {
    Axios.get(genderUrl.getAllGenders).then(function (response) {
      context.commit('GET_ALL_GENDERS', response.data)
    })
  },
  get_all_genders2 (context) {
    Axios.get(genderUrl.getAllGenders2).then(function (response) {
      context.commit('GET_ALL_GENDERS', response.data)
    })
  }
}
